/** Teto do backend: 10^13 centavos por lançamento. */
export const AMOUNT_MAX_MINOR = 10 ** 13;

const THOUSANDS = /^\d{1,3}(\.\d{3})+$/;

/**
 * Converte o que a pessoa digitou ("1.234,56", "12,3", "1234.56", "R$ 10") em centavos inteiros.
 * Só aritmética de inteiros sobre a string: nunca passa por float. Devolve null se inválido ou ≤ 0.
 */
export function parseMoneyInput(raw: string): number | null {
  const s = raw.replace(/R\$/i, "").replace(/\s/g, "");
  if (!/^[\d.,]+$/.test(s)) return null;

  let reais: string;
  let cents = "";
  if (s.includes(",")) {
    const parts = s.split(",");
    if (parts.length !== 2) return null;
    const [int = "", dec = ""] = parts;
    if (!/^\d{1,2}$/.test(dec)) return null;
    if (int.includes(".") && !THOUSANDS.test(int)) return null;
    reais = int.replace(/\./g, "");
    cents = dec;
  } else if (s.includes(".")) {
    if (THOUSANDS.test(s)) {
      reais = s.replace(/\./g, "");
    } else {
      const parts = s.split(".");
      if (parts.length !== 2 || !/^\d{1,2}$/.test(parts[1] ?? "")) return null;
      reais = parts[0] ?? "";
      cents = parts[1] ?? "";
    }
  } else {
    reais = s;
  }
  if (!/^\d+$/.test(reais)) return null;
  const minor = Number(reais) * 100 + Number(cents.padEnd(2, "0") || "0");
  if (!Number.isSafeInteger(minor) || minor <= 0 || minor > AMOUNT_MAX_MINOR) return null;
  return minor;
}

export function formatMoney(amountMinor: number, currency = "BRL"): string {
  return new Intl.NumberFormat("pt-BR", { style: "currency", currency })
    .format(amountMinor / 100)
    .replace(/ /g, " ");
}

/** Centavos → texto para preencher um campo de edição ("1234,56"). */
export function toInputValue(amountMinor: number): string {
  const abs = Math.abs(amountMinor);
  const reais = Math.floor(abs / 100);
  const cents = String(abs % 100).padStart(2, "0");
  return `${amountMinor < 0 ? "-" : ""}${reais},${cents}`;
}

/** Rótulo de eixo compacto: 520000 → "R$ 5,2 mil". */
export function formatMoneyCompact(amountMinor: number, currency = "BRL"): string {
  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency,
    notation: "compact",
    maximumFractionDigits: 1,
  })
    .format(amountMinor / 100)
    .replace(/ /g, " ");
}

export function formatPercent(value: number): string {
  return `${new Intl.NumberFormat("pt-BR", { maximumFractionDigits: 1 }).format(value)}%`;
}
